$(document).ready(function() {


 $(document).on('click keydown', '.details-cart-drawer .cart-note-summary-title', function (e) {
    if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))) {
        e.preventDefault();
        $(this).next('.accordion-content').slideToggle();
        $(this).toggleClass('open-note');
    }
});


  $(document).on('keyup', '.cartdrawer-note-text-area', function() {
    var cart_note = $.trim($('.cartdrawer-note-text-area').val());
        $.ajax({
          url: '/cart/update.js',
          dataType: 'json',
          type: 'POST',
          data: {
              note: cart_note
          },
          success: function(data) {
              console.log(data);
          }
        });
   });



});

